export const IGNORE_FILTER_CLASS = 'element-to-image-opt-out';
export const CONTAINER_CLASS = 'element-to-image-container';
export const SCROLL_CLASS = 'element-to-image-scroll';
